import {Component, OnInit, OnDestroy, Input, ViewChild, ElementRef} from '@angular/core';
import {ApiService} from '../services/api.service';
import {TranslateService} from '@ngx-translate/core';
import {InternalService} from '../services/internal.service';
import {ActivatedRoute, Router} from '@angular/router';

import {Location} from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(public apiService: ApiService, public translate: TranslateService,
              private route: ActivatedRoute,
              public router: Router,
              private Location: Location,
              public internalService: InternalService) {
  }


  @Input() name: string;

  public isCollapsed = true;


  ngOnInit() {
    // console.log(this.Location.path());
    if(this.Location.path().split('/')[2]){
      if (this.Location.path().split('/')[2] === 'en') {
        this.changeLanguage('en-us');
      }
    }
  }

  ScrollIntoView(elem: string) {
    document.querySelector(elem).scrollIntoView({behavior: 'smooth', block: 'start'});
  }


  changeLanguage(lang) {
    if (this.Location.path().split('/')[1] === 'privacy') {

      this.router.navigate([this.Location.path().split('/')[1].toString()]);
    }
    if (this.Location.path().split('/')[1] === 'terms') {
      this.router.navigate([this.Location.path().split('/')[1].toString()]);
    }
    this.internalService.changeLang(lang, 1);

  }
}
